// Module
var code = "<div class=\"modal-header\"> <div class=\"close\" ng-click=\"$ctrl.cancel()\"> <i class=\"fa fa-times\" aria-hidden=\"true\"></i> </div> </div> <div class=\"modal-body file-preview-modal\"> <file-viewer kid=\"$ctrl.kid\"></file-viewer> </div> ";
// Exports
export default code;